"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalTitle = exports.ModalContainer = exports.CloseIcon = void 0;
exports.PaperComponent = PaperComponent;
exports.StyledTitleSection = exports.StyledDialogContent = exports.StyledDialogActions = exports.StyledDialog = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _constants = require("../../constants");
var _default_theme = _interopRequireDefault(require("./default_theme"));
var _xicon = _interopRequireDefault(require("../../icons/xicon"));
var _typography = require("../../typography");
var _excluded = ["modalBodyOverflow"]; // @ts-expect-error - TS7016 - Could not find a declaration file for module './default_theme'. 'src/azalea/components/modals/default_theme.js' implicitly has an 'any' type.
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function PaperComponent(props) {
  return /*#__PURE__*/React.createElement(_reactDraggable["default"], {
    cancel: '[class*="MuiDialogContent-root"]'
  }, /*#__PURE__*/React.createElement(_Paper["default"], props));
}
var TitleSection = function TitleSection(props) {
  var title = props.title,
    closeModal = props.closeModal,
    displayXIcon = props.displayXIcon,
    draggable = props.draggable;
  return /*#__PURE__*/React.createElement(StyledTitleSection, {
    className: "title-section",
    style: {
      cursor: draggable ? 'move' : 'auto'
    }
  }, /*#__PURE__*/React.createElement(ModalTitle, {
    id: "modal_title"
  }, title), displayXIcon && /*#__PURE__*/React.createElement(CloseIcon, {
    onClick: closeModal
  }));
};
var ModalContainer = exports.ModalContainer = function ModalContainer(props) {
  var children = props.children,
    open = props.open,
    closeModal = props.closeModal,
    title = props.title,
    displayXIcon = props.displayXIcon,
    fullScreen = props.fullScreen,
    fullWidth = props.fullWidth,
    maxWidth = props.maxWidth,
    width = props.width,
    onClose = props.onClose,
    modalProps = props.modalProps,
    id = props.id,
    ariaLabelledBy = props.ariaLabelledBy,
    ariaDescribedBy = props.ariaDescribedBy,
    className = props.className,
    draggable = props.draggable,
    disableEnforceFocus = props.disableEnforceFocus;
  if (fullScreen) {
    console.warn('FULL SCREEN MODAL - Please do not use this modal yet. The design/styling of the full screen modal is still in progress.');
  }
  return /*#__PURE__*/React.createElement(_default_theme["default"], null, /*#__PURE__*/React.createElement(StyledDialog, (0, _extends2["default"])({
    open: open,
    onClose: closeModal,
    onExit: onClose,
    fullScreen: fullScreen,
    fullWidth: fullWidth,
    maxWidth: maxWidth,
    width: width,
    className: className,
    id: id,
    "aria-labelledby": ariaLabelledBy || 'modal_title',
    "aria-describedby": ariaDescribedBy
  }, modalProps, draggable ? {
    PaperComponent: PaperComponent
  } : {}, {
    disableEnforceFocus: disableEnforceFocus
  }), /*#__PURE__*/React.createElement(TitleSection, {
    title: title,
    closeModal: closeModal,
    displayXIcon: displayXIcon,
    draggable: draggable
  }), children));
};
var StyledDialogContent = exports.StyledDialogContent = (0, _styledComponents["default"])(function (_ref) {
  var modalBodyOverflow = _ref.modalBodyOverflow,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_DialogContent["default"], rest);
}).withConfig({
  displayName: "shared__StyledDialogContent"
})(["&&{padding-top:20px;padding-bottom:0px;padding-left:20px;", " font-size:14px;p{font-size:14px;}", ";}"], (0, _constants.fontWeight)('normal'), function (_ref2) {
  var modalBodyOverflow = _ref2.modalBodyOverflow;
  return modalBodyOverflow && (0, _styledComponents.css)(["overflow:", ";"], modalBodyOverflow);
});
var StyledDialogActions = exports.StyledDialogActions = (0, _styledComponents["default"])(function (props) {
  return /*#__PURE__*/React.createElement(_DialogActions["default"], props);
}).withConfig({
  displayName: "shared__StyledDialogActions"
})(["&.MuiDialogActions-spacing{padding:20px;}"]);
var StyledDialog = exports.StyledDialog = (0, _styledComponents["default"])(function (props) {
  return /*#__PURE__*/React.createElement(_Dialog["default"], props);
}).withConfig({
  displayName: "shared__StyledDialog"
})([".MuiDialog-paperWidthXs{max-width:300px;}.MuiDialog-paperWidthSm{max-width:400px;}.MuiDialog-paperWidthMd{max-width:600px;}.MuiDialog-paperWidthLg{max-width:800px;}.MuiDialog-paperWidthXl{max-width:1000px;}.MuiDialog-paperFullScreen{max-width:100%;}", ";"], function (props) {
  return props.width && (0, _styledComponents.css)(["&& .MuiDialog-paper{max-width:none;width:", ";}"], props.width);
});
var StyledTitleSection = exports.StyledTitleSection = _styledComponents["default"].div.withConfig({
  displayName: "shared__StyledTitleSection"
})(["position:relative;background-color:", ";"], _constants.colors.lightestGrey);

// @ts-expect-error - TS2344 - Type 'Record<any, any>' does not satisfy the constraint 'keyof IntrinsicElements | ComponentType<any>'.
var ModalTitle = exports.ModalTitle = (0, _styledComponents["default"])(_typography.SectionHeader).withConfig({
  displayName: "shared__ModalTitle"
})(["margin:15px 0 15px 20px;"]);
var CloseIcon = exports.CloseIcon = (0, _styledComponents["default"])(_xicon["default"]).withConfig({
  displayName: "shared__CloseIcon"
})(["position:absolute;right:18px;top:50%;transform:translateY(-50%);"]);